module.exports = __webpack_public_path__ + "img/tutorial-f02-05.e269dae1.png";